import { useEffect } from "react";
import "../styles/Burial.css";
import { useNavigate } from "react-router";

const Burial = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <div className="burialHero">
        <div className="burialHeading">
          <h2>Mrs Ezinne Cecilia Akukananwa Igwegbu</h2>
          <p>The Matriarch of Igwegbu family</p>
        </div>
        <img src="" alt="" />
        <p className="burialHeadingInfo">
          With gratitude to God for a life well spent, we the Igwegbu family of
          Imama Akama Oghe in Ezeagu Local Government Area of Enugu State
          announce the transition to glory of our <b>beloved</b> mother,
          mother-inlaw, sister, sister-in-law, aunt, niece, grandmother, and
          great-grandmother, the Matriarch of Igwegbu family, Ezinne Cecilia
          Akukananwa Igwegbu, Nee Nzekwe (Nneoma) who passed away after a brief
          illness on <b>Thursday</b> November 14th, 2024 at <b>Maryland</b>,
          USA. <br />
          <br />
          <b>She is survived by:</b>
          <br />
          <p className="survivedBy">
            <span>Dr. Mrs. Priscilla Aneke, daughter</span>
            <span>Chief (Engr.) Elias Igwegbu (Kpakpando Gburugburu) Son</span>
            
            <span>Dr. Mrs. Regina Enebechi, daughter</span>
            
            <span>Ozo Richard Igwegbu (Ekeweze II), Son</span>
            
            <span>Mrs. Amaka Okafor (CNA), daughter</span>
            
            <span>Chief Engr. (Dr.) Donald Igwegbu (Odera), Son</span>
            
            <span>Mrs. Ijeoma Ugwuozor, daughter</span>
            
            <span>Sisters in-laws</span>
            
            <span>Sisters in-laws</span> 
            <span>26 grandchildren and 5 Great-grandchildren.</span>
            
          </p>
        </p>
        <div className="burialButtons">
          <button onClick={() => navigate("tributes/add")}>
            Write a Tribute
          </button>
          <button onClick={() => navigate("family-tree/connect")}>
            Connect to family Tree
          </button>
        </div>
      </div>

      <div className="arrangementWrapper">
        <h2>Burial Arrangement </h2>

        <div className="arrangementCards">
            {/* Christian Wake Keeping */}
            <div className="arrangement">
                <div className="">
                <h3>Christian Wake Keeping</h3>
                <p>
                    <b>Thursday</b>, December 26th, 2024, 6PM: All night Christian wake-keeping at 
                    <b> The Light House (TLH)</b>, <b>Igwegbu's family Home</b>, 
                    Imama Akama Oghe, Ezeagu <b>L.G.A</b>, Enugu State.
                </p>
                </div>
                <div className="">
                <h3>Date & Time</h3>
                <p><b>Thursday</b>, December 26th, 2024, 6PM</p>
                </div>
                <div className="">
                <h3>Venue</h3>
                <p>
                    The Light House (TLH), <b>Igwegbu's family Home</b>, 
                    Imama Akama Oghe, Ezeagu <b>L.G.A</b>, Enugu State.
                </p>
                </div>
            </div>

            {/* Procession and Lying in State */}
            <div className="arrangement">
                <div className="">
                <h3>Procession & Lying in State</h3>
                <p>
                    Body leaves Eastern Nigeria Medical Center, Enugu to her hometown Imama Akama Oghe, with a brief stop-over at her maiden home (Nzekwe’s Compound, Umugwa, Amansiodo Oghe, Ezeagu L.G.A).
                </p>
                <p>
                    <b>8AM</b>: Lying in state at the <b>Igwegbu family home</b> (The Light House), Imama Akama Oghe, Ezeagu L.G.A, Enugu State.
                </p>
                </div>
                <div className="">
                <h3>Date & Time</h3>
                <p>
                    <b>Friday</b>, December 27th, 2024, 7AM - Procession. <br />
                    <b>Friday</b>, December 27th, 2024, 8AM - Lying in State.
                </p>
                </div>
            </div>

            {/* Funeral Mass */}
            <div className="arrangement">
                <div className="">
                <h3>Funeral Mass</h3>
                <p>
                    Funeral mass at St. Mary's Catholic Church, Akama Oghe, Ezeagu L.G.A, Enugu State. Interment and condolences follow immediately at the <b>Igwegbu family home</b> (The Light House), Akama Oghe, Ezeagu L.G.A, Enugu State.
                </p>
                </div>
                <div className="">
                <h3>Date & Time</h3>
                <p><b>Friday</b>, December 27th, 2024, 10AM</p>
                </div>
                <div className="">
                <h3>Venue</h3>
                <p>
                    St. Mary's Catholic Church, Akama Oghe, Ezeagu L.G.A, Enugu State.
                </p>
                </div>
            </div>

            {/* Thanksgiving Service */}
            <div className="arrangement">
                <div className="">
                <h3>Thanksgiving Service</h3>
                <p>
                    Thanksgiving Service at St. Mary’s Catholic Church, Akama Oghe, Ezeagu L.G.A, Enugu State.
                </p>
                </div>
                <div className="">
                <h3>Date & Time</h3>
                <p><b>Sunday</b>, December 29th, 2024, 9AM</p>
                </div>
                <div className="">
                <h3>Venue</h3>
                <p>
                    St. Mary’s Catholic Church, Akama Oghe, Ezeagu L.G.A, Enugu State.
                </p>
                </div>
            </div>

            {/* Announcer */}
            <div className="arrangement">
                <div className="">
                <h3>Announcer</h3>
                <p>
                    Chief (Engr.) Elias Igwegbu (Kpakpando Gburugburu) for the Family.
                </p>
                </div>
            </div>
            </div>

      </div>

      <div className="eventGallery">
        <h3>Event Gallery</h3>

        <div className="galleryWrapper">
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
        </div>
        <div className="galleryButton">
          <button>Add Pictures / Videos</button>
        </div>
      </div>
    </>
  );
};

export default Burial;
